/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as RSlugRouteImport } from './routes/r.$slug'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppTemplatesRouteImport } from './routes/_app/templates'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppReviewRouteImport } from './routes/_app/review'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppAlertsRouteImport } from './routes/_app/alerts'
import { Route as AppLinksIndexRouteImport } from './routes/_app/links/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppCampaignsIndexRouteImport } from './routes/_app/campaigns/index'
import { Route as AppLinksNewRouteImport } from './routes/_app/links/new'
import { Route as AppClientsNewRouteImport } from './routes/_app/clients/new'
import { Route as AppClientsImportRouteImport } from './routes/_app/clients/import'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients/$clientId'
import { Route as AppCampaignsNewRouteImport } from './routes/_app/campaigns/new'
import { Route as AppCampaignsCampaignIdRouteImport } from './routes/_app/campaigns/$campaignId'
import { Route as AppLinksLinkIdIndexRouteImport } from './routes/_app/links/$linkId/index'
import { Route as AppLinksLinkIdPosterRouteImport } from './routes/_app/links/$linkId/poster'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const RSlugRoute = RSlugRouteImport.update({
  id: '/r/$slug',
  path: '/r/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewRoute = AppReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppLinksIndexRoute = AppLinksIndexRouteImport.update({
  id: '/links/',
  path: '/links/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsIndexRoute = AppCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AppRoute,
} as any)
const AppLinksNewRoute = AppLinksNewRouteImport.update({
  id: '/links/new',
  path: '/links/new',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsNewRoute = AppClientsNewRouteImport.update({
  id: '/clients/new',
  path: '/clients/new',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsImportRoute = AppClientsImportRouteImport.update({
  id: '/clients/import',
  path: '/clients/import',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsNewRoute = AppCampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsCampaignIdRoute = AppCampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => AppRoute,
} as any)
const AppLinksLinkIdIndexRoute = AppLinksLinkIdIndexRouteImport.update({
  id: '/links/$linkId/',
  path: '/links/$linkId/',
  getParentRoute: () => AppRoute,
} as any)
const AppLinksLinkIdPosterRoute = AppLinksLinkIdPosterRouteImport.update({
  id: '/links/$linkId/poster',
  path: '/links/$linkId/poster',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/alerts': typeof AppAlertsRoute
  '/audit': typeof AppAuditRoute
  '/review': typeof AppReviewRoute
  '/settings': typeof AppSettingsRoute
  '/templates': typeof AppTemplatesRoute
  '/users': typeof AppUsersRoute
  '/r/$slug': typeof RSlugRoute
  '/campaigns/$campaignId': typeof AppCampaignsCampaignIdRoute
  '/campaigns/new': typeof AppCampaignsNewRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/clients/import': typeof AppClientsImportRoute
  '/clients/new': typeof AppClientsNewRoute
  '/links/new': typeof AppLinksNewRoute
  '/campaigns/': typeof AppCampaignsIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/links/': typeof AppLinksIndexRoute
  '/links/$linkId/poster': typeof AppLinksLinkIdPosterRoute
  '/links/$linkId/': typeof AppLinksLinkIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/alerts': typeof AppAlertsRoute
  '/audit': typeof AppAuditRoute
  '/review': typeof AppReviewRoute
  '/settings': typeof AppSettingsRoute
  '/templates': typeof AppTemplatesRoute
  '/users': typeof AppUsersRoute
  '/r/$slug': typeof RSlugRoute
  '/': typeof AppIndexRoute
  '/campaigns/$campaignId': typeof AppCampaignsCampaignIdRoute
  '/campaigns/new': typeof AppCampaignsNewRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/clients/import': typeof AppClientsImportRoute
  '/clients/new': typeof AppClientsNewRoute
  '/links/new': typeof AppLinksNewRoute
  '/campaigns': typeof AppCampaignsIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/links': typeof AppLinksIndexRoute
  '/links/$linkId/poster': typeof AppLinksLinkIdPosterRoute
  '/links/$linkId': typeof AppLinksLinkIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/review': typeof AppReviewRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/templates': typeof AppTemplatesRoute
  '/_app/users': typeof AppUsersRoute
  '/r/$slug': typeof RSlugRoute
  '/_app/': typeof AppIndexRoute
  '/_app/campaigns/$campaignId': typeof AppCampaignsCampaignIdRoute
  '/_app/campaigns/new': typeof AppCampaignsNewRoute
  '/_app/clients/$clientId': typeof AppClientsClientIdRoute
  '/_app/clients/import': typeof AppClientsImportRoute
  '/_app/clients/new': typeof AppClientsNewRoute
  '/_app/links/new': typeof AppLinksNewRoute
  '/_app/campaigns/': typeof AppCampaignsIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/links/': typeof AppLinksIndexRoute
  '/_app/links/$linkId/poster': typeof AppLinksLinkIdPosterRoute
  '/_app/links/$linkId/': typeof AppLinksLinkIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/alerts'
    | '/audit'
    | '/review'
    | '/settings'
    | '/templates'
    | '/users'
    | '/r/$slug'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/clients/$clientId'
    | '/clients/import'
    | '/clients/new'
    | '/links/new'
    | '/campaigns/'
    | '/clients/'
    | '/links/'
    | '/links/$linkId/poster'
    | '/links/$linkId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/alerts'
    | '/audit'
    | '/review'
    | '/settings'
    | '/templates'
    | '/users'
    | '/r/$slug'
    | '/'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/clients/$clientId'
    | '/clients/import'
    | '/clients/new'
    | '/links/new'
    | '/campaigns'
    | '/clients'
    | '/links'
    | '/links/$linkId/poster'
    | '/links/$linkId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/alerts'
    | '/_app/audit'
    | '/_app/review'
    | '/_app/settings'
    | '/_app/templates'
    | '/_app/users'
    | '/r/$slug'
    | '/_app/'
    | '/_app/campaigns/$campaignId'
    | '/_app/campaigns/new'
    | '/_app/clients/$clientId'
    | '/_app/clients/import'
    | '/_app/clients/new'
    | '/_app/links/new'
    | '/_app/campaigns/'
    | '/_app/clients/'
    | '/_app/links/'
    | '/_app/links/$linkId/poster'
    | '/_app/links/$linkId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RSlugRoute: typeof RSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/r/$slug': {
      id: '/r/$slug'
      path: '/r/$slug'
      fullPath: '/r/$slug'
      preLoaderRoute: typeof RSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/review': {
      id: '/_app/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AppReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/links/': {
      id: '/_app/links/'
      path: '/links'
      fullPath: '/links/'
      preLoaderRoute: typeof AppLinksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns/': {
      id: '/_app/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AppCampaignsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/links/new': {
      id: '/_app/links/new'
      path: '/links/new'
      fullPath: '/links/new'
      preLoaderRoute: typeof AppLinksNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/new': {
      id: '/_app/clients/new'
      path: '/clients/new'
      fullPath: '/clients/new'
      preLoaderRoute: typeof AppClientsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/import': {
      id: '/_app/clients/import'
      path: '/clients/import'
      fullPath: '/clients/import'
      preLoaderRoute: typeof AppClientsImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns/new': {
      id: '/_app/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof AppCampaignsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns/$campaignId': {
      id: '/_app/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof AppCampaignsCampaignIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/links/$linkId/': {
      id: '/_app/links/$linkId/'
      path: '/links/$linkId'
      fullPath: '/links/$linkId/'
      preLoaderRoute: typeof AppLinksLinkIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/links/$linkId/poster': {
      id: '/_app/links/$linkId/poster'
      path: '/links/$linkId/poster'
      fullPath: '/links/$linkId/poster'
      preLoaderRoute: typeof AppLinksLinkIdPosterRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAlertsRoute: typeof AppAlertsRoute
  AppAuditRoute: typeof AppAuditRoute
  AppReviewRoute: typeof AppReviewRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTemplatesRoute: typeof AppTemplatesRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCampaignsCampaignIdRoute: typeof AppCampaignsCampaignIdRoute
  AppCampaignsNewRoute: typeof AppCampaignsNewRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppClientsImportRoute: typeof AppClientsImportRoute
  AppClientsNewRoute: typeof AppClientsNewRoute
  AppLinksNewRoute: typeof AppLinksNewRoute
  AppCampaignsIndexRoute: typeof AppCampaignsIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppLinksIndexRoute: typeof AppLinksIndexRoute
  AppLinksLinkIdPosterRoute: typeof AppLinksLinkIdPosterRoute
  AppLinksLinkIdIndexRoute: typeof AppLinksLinkIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAlertsRoute: AppAlertsRoute,
  AppAuditRoute: AppAuditRoute,
  AppReviewRoute: AppReviewRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTemplatesRoute: AppTemplatesRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppCampaignsCampaignIdRoute: AppCampaignsCampaignIdRoute,
  AppCampaignsNewRoute: AppCampaignsNewRoute,
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppClientsImportRoute: AppClientsImportRoute,
  AppClientsNewRoute: AppClientsNewRoute,
  AppLinksNewRoute: AppLinksNewRoute,
  AppCampaignsIndexRoute: AppCampaignsIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppLinksIndexRoute: AppLinksIndexRoute,
  AppLinksLinkIdPosterRoute: AppLinksLinkIdPosterRoute,
  AppLinksLinkIdIndexRoute: AppLinksLinkIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RSlugRoute: RSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
